import { createFileRoute } from '@tanstack/react-router';
import { Articles } from '@/features/content/Articles';
import { MobileArticles } from '@/features/content/mobile/MobileArticles';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';

/** Lista articoli (Knowledge Base) — MaeDesign. Il dettaglio è de-nested
 *  (`articles_.$id`) così questa resta una route foglia per `/articles`. */
export const Route = createFileRoute('/_app/articles')({ component: ArticlesPage });

/** Selettore: schermata mobile dedicata vs lista desktop. */
function ArticlesPage() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileArticles /> : <Articles />;
}
